module.exports = __webpack_public_path__ + "img/plus.9b17dc39.svg";